(ns minorodata.components.pipeline-editor.entities-panel
  (:require
   ["react" :as react]
   [minorodata.components.pipeline-editor.lists :refer [extracts-content
                                                        tables-content
                                                        transforms-content]]
   [minorodata.components.pipeline-editor.search :refer [search]]
   [minorodata.components.pipeline-editor.utils :refer [tab-icon]]
   [ui.tabs :as tabs]
   [re-posh.core :as re-posh]))

(defn sidebar-tabs []
  (let [[active set-active] (react/useState "transforms")]
    [tabs/tabs-root {:value           active
                     :on-value-change set-active
                     :class           "flex-1 grid grid-rows-[auto_1fr] overflow-hidden"}
     [tabs/tabs-list {:variant    :underlined
                      :full-width true}
      [tabs/tabs-trigger {:value   "extracts"
                          :variant :underlined
                          :size    :small
                          :data-cy :pe-sidebar-tab-extracts
                          :class   "gap-2 radix-state-inactive:[&>span]:hidden"}
       [tab-icon {:type "extract"}]
       [:span "Extracts"]]
      [tabs/tabs-trigger {:value   "transforms"
                          :variant :underlined
                          :size    :small
                          :data-cy :pe-sidebar-tab-transforms
                          :class   "gap-2 radix-state-inactive:[&>span]:hidden"}
       [tab-icon {:type "transform"}]
       [:span "Transforms"]]
      [tabs/tabs-trigger {:value   "tables"
                          :variant :underlined
                          :size    :small
                          :data-cy :pe-sidebar-tab-tables
                          :class   "gap-2 radix-state-inactive:[&>span]:hidden"}
       [tab-icon {:type "table"}]
       [:span "Tables"]]]
     [tabs/tabs-content {:value "extracts"
                         :class "overflow-y-auto"}
      [extracts-content {:open-as-preview? true}]]
     [tabs/tabs-content {:value "transforms"
                         :class "overflow-y-auto"}
      [transforms-content {:open-as-preview? true}]]
     [tabs/tabs-content {:value "tables"
                         :class "overflow-y-auto"}
      [tables-content {:open-as-preview? true}]]]))

(defn entities-panel []
  (when @(re-posh/subscribe [:pipeline-editor.subs/enabled-feature :sidebar])
    [:div {:class "h-full overflow-hidden flex flex-col bg-kleene-background"}
     [:div {:class "p-2 border-b border-b-kleene-neutral-01 dark:border-b-kleene-dark-02"}
      [search {:align "start"}]]
     [:f> sidebar-tabs]]))
